import AppModalContainer from '@nxsys/components/AppModalContainer';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import React, { useRef, useState } from 'react';
import BankForm, { BankFormRef, BankValues } from './BankForm';

type CreateBankModalProps = {
  isOpen: boolean;
  toggle: () => void;
  onSubmit: (params: BankValues) => Promise<void>;
};

const CreateBankModal: React.FC<CreateBankModalProps> = ({
  isOpen,
  toggle,
  onSubmit,
}: CreateBankModalProps) => {
  const { messages } = useTypedIntl();
  const formRef = useRef<BankFormRef>(null);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (values: BankValues) => {
    try {
      setIsSubmitting(true);
      await onSubmit(values);
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AppModalContainer
      title={messages['common.createBank']}
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: messages['common.cancel'],
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: messages['common.save'],
          buttonType: 'primary',
          onClick: () => formRef.current?.submit(),
          loading: isSubmitting,
          disabled: isSubmitting,
        },
      ]}
      minHeight="200px"
    >
      <BankForm formRef={formRef} onSubmit={handleSubmit} />
    </AppModalContainer>
  );
};

export default CreateBankModal;
